import React from 'react';
import { SvgIcon } from '../../';
function ExternalLinkIcon(props) {
    return (React.createElement(SvgIcon, { ...props },
        React.createElement("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round" },
            React.createElement("path", { d: "M12.5 6.5H3.65v13.75h14.47v-8.12M14.82 4.27h5.66v5.66M9.52 15.23l10.6-10.6" }))));
}
export default ExternalLinkIcon;
//# sourceMappingURL=ExternalLinkIcon.js.map